import type { ReactNode } from 'react'

type Tone = 'neutral' | 'green' | 'red' | 'amber' | 'indigo' | 'blue'

const tones: Record<Tone, string> = {
  neutral: 'bg-gray-100 text-gray-600',
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  amber: 'bg-amber-100 text-amber-700',
  indigo: 'bg-accent text-accent-text',
  blue: 'bg-slate-100 text-slate-700',
}

export function Badge({ tone = 'neutral', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${tones[tone]}`}>
      {children}
    </span>
  )
}
